import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import Box from '@mui/material/Box';
import type { FormNotifications } from '@repo/shared/types';

import { useMainHubStoreState } from '@/store/main-hub.store';
import {
  WarningFieldsNotification,
  DefaultFieldsNotification,
} from '@/components/loan-form/loan-recipient/recipient-notification/field-notification';

import { LiberisRecipientDetailsList } from './liberis-recipient-details-list';

export function LiberisCheckYourData() {
  const { merchantResponseData } = useMainHubStoreState();
  const [notificationType, setNotificationType] = useState<FormNotifications>('default');

  const phoneField = merchantResponseData?.data?.merchantData?.phone;
  const emailField = merchantResponseData?.data?.merchantData?.email;

  const isPhoneFieldEmpty = isEmpty(phoneField);
  const isEmailFieldEmpty = isEmpty(emailField);

  useEffect(() => {
    let notificationTypeToSet: FormNotifications = 'default';
    if (isPhoneFieldEmpty || isEmailFieldEmpty) {
      notificationTypeToSet = 'warning';
    }
    setNotificationType(notificationTypeToSet);
  }, [phoneField, emailField]);

  if (!merchantResponseData) {
    return null;
  }

  return (
    <>
      <LiberisRecipientDetailsList merchantResponseData={merchantResponseData} />
      <Box sx={{ marginTop: '20px' }}>
        {notificationType === 'warning' ? (
          <WarningFieldsNotification
            isPhoneFieldEmpty={isPhoneFieldEmpty}
            isMailFieldEmpty={isEmailFieldEmpty}
          />
        ) : null}
        {notificationType === 'default' ? <DefaultFieldsNotification /> : null}
      </Box>
    </>
  );
}
